import 'mlmi-library'
import 'jquery.easing'
import Carousel, { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'
import Burger from 'mlmi-library/components/burger/v1/burger'
import Form from 'mlmi-library/components/form/v1/form'
import Popup from 'mlmi-library/components/popup/v1/popup'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar'
import 'mlmi-library/components/fixed-content/v1/fixed-content'
import 'mlmi-library/modules/scroll-events/v1/scroll-events'
import 'mlmi-library/plugins/bem'
import 'mlmi-library/plugins/scroll-to'
import 'mlmi-library/components/fade-in/v1/fade-in'
import 'mlmi-library/components/form/v1/form-steps'
import 'mlmi-library/components/select/v1/select'
import 'mlmi-library/components/quantity/v1/quantity'
export { Scrollbar, Carousel, Carousel_CoreInit, Burger, Mobile, Form, Popup }

CoreDetect_WebP()
